import React, { FormEvent } from 'react';
import { Header, Footer, Modal } from '@/components';
import { FormData, FormErrors, OnChangeFormInput } from 'src/hooks';
import ClientNotification from '@/model/ClientNotification';
import { SupportBotton } from '@/components/SupportBotton';
import { CheckClientDocument } from '@/model/CheckClientDocument';
import RecoverAccount from '@/model/RecoverAccount';
import PasswordRecoveryStrategy from '@/model/PasswordRecoveryStrategy';
import { PostMessageRequest } from '@/model/PostMessageRequest';
import { PostMessageResponse } from '@/model/PostMessageResponse';
import { PostMessageCheckRequest } from '@/model/PostMessageCheckRequest';
import { SearchFaceByImageResponse } from '@/model/SearchFaceByImageResponse';
import { BiometricCheckErrorResponse } from '@/model/BiometricCheckErrorResponse';
import {
  CallChangePasswordContent,
  ChangePasswordContent,
  ConfirmEmailForgotPasswordContent,
  LoginContent,
  RegisterConfirmContent,
  TermsContent,
} from '../../../components';
import { ShouldShowModal, ShouldShowModalProps } from '../../../types';
import { LogoutContent } from '../../../components/LogoutContent';
import { ChangePasswordCheckEmailContent } from '../../../components/ChangePasswordCheckEmailContent';
import { ChangeClientDataContent } from '../../../components/ChangeClientDataContent';
import { CheckEmailContent } from '../../../components/CheckEmailContent';
import { ConfirmEmailContent } from '../../../components/ConfirmEmailContent';
import { AddressContent } from '../../../components/AddressContent';
import { BiometricFaceValid } from '../../../components/BiometricFaceValid';
import { CheckAccountContent } from '../../../components/CheckAccountContent';
import { BiometriChangePassword } from '../../../components/BiometriChangePassword';
import { BiometricFaceCheck } from '../../../components/BiometricFaceCheck';
import { ForgotPasswordBiometricContent } from '../../../components/ForgotPasswordBiometricContent';
import { CallChangePasswordDocumentContent } from '../../../components/CallChangePasswordDocumentContent';

interface StateProps {
  state: boolean;
  homepage: boolean;
  notifications: ClientNotification[];
  visibleModal: boolean;
  titleModal: string | React.ReactNode;
  shouldShowModal: ShouldShowModal;
  onShouldShowModal: ({ value, newTitle }: ShouldShowModalProps) => void;
  biometricFaceRequest?: PostMessageRequest;
  formDataCheckEmail: FormData;
  formErrorsCheckEmail: FormErrors;
  onChangeFormCheckEmail: OnChangeFormInput;
  onSendConfirmEmail: () => void;
  formDataConfirmEmail: FormData;
  formErrorsConfirmEmail: FormErrors;
  onChangeFormConfirmEmail: OnChangeFormInput;
  formDataChangePasswordDocument: FormData;
  formErrorsChangePasswordDocument: FormErrors;
  onChangeFormChangePasswordDocument: OnChangeFormInput;
  onConfirmEmail: () => void;
  onResendEmail: () => void;
  shouldShowPasswordToText: boolean;
  // shouldShowPasswordToText2: boolean;
  formDataLogin: FormData;
  formErrorsLogin: FormErrors;
  enableLoginPassword: boolean;
  onChangeFormInputLogin: OnChangeFormInput;
  checkClientDocument?: CheckClientDocument;
  recoverAccount?: RecoverAccount;
  formDataAddress: FormData;
  formErrorsAddress: FormErrors;
  onChangeFormInputAddress: OnChangeFormInput;
  onChangeCEPAddress: (value: string) => void;
  onSaveAddress: () => void;
  // onChangeCEP: (value: string) => void;
  formDataChangeClientData: FormData;
  formErrorsChangeClientData: FormErrors;
  onChangeFormInputChangeClientData: OnChangeFormInput;
  // formDataRegister: FormData;
  // formErrorsRegister: FormErrors;
  // onChangeFormInputRegister: OnChangeFormInput;
  // formDataForgotPassword: FormData;
  // formErrorsForgotPassword: FormErrors;
  // onChangeFormInputForgotPassword: OnChangeFormInput;
  formDataRegisterConfirm: FormData;
  formErrorsRegisterConfirm: FormErrors;
  onChangeFormInputRegisterConfirm: OnChangeFormInput;
  biometricCheckFaceRequest?: PostMessageCheckRequest;
  onAnalysisCheckFaceComplete: (data: SearchFaceByImageResponse[]) => void;
  onAnalysisCheckFaceError: (data: BiometricCheckErrorResponse) => void;
  formDataChangePassword: FormData;
  formErrorsChangePassword: FormErrors;
  onChangeFormInputChangePassword: OnChangeFormInput;
  name: string;
  children: React.ReactNode;
  showCloseButton: boolean;
  disableCloseOutside?: boolean;
}

interface DispathProps {
  onGoTo: (href: string) => void;
  handleOnSignIn: () => void;
  handleOnSignUp: () => void;
  handleOnLogout: () => void;
  onSubmitLogout: () => void;
  onCloseModal: () => void;
  handleOnCart: () => void;
  onToggleModal: () => void;
  onTogglePasswordToText: () => void;
  // onTogglePasswordToText2: () => void;
  onCheckCPF: () => void;
  onSubmitLogin: (e: FormEvent) => void;
  // onSubmitRegister: (e: FormEvent) => void;
  onAnalysisComplete: (data: PostMessageResponse) => void;
  onSubmitForgotPassword: (e: FormEvent) => void;
  onChangePersonData: () => void;
  onSubmitChangeClientData: (e: FormEvent) => void;
  onSubmitChangePassword: (e: FormEvent) => void;
  onSubmitRegisterConfirm: (e: FormEvent) => void;
  onSubmitResendCode: (e: FormEvent) => void;
  onSubmitResendEmail: (e: FormEvent) => void;
  isUserEmail: (e: FormEvent) => void;
  onSubmitDocument: (e: FormEvent) => void;
  onSupportClick: () => void;
}

type AuthWrapperContainerProps = StateProps & DispathProps;

export const AuthWrapperContainer: React.FC<AuthWrapperContainerProps> = ({
  state,
  homepage,
  notifications,
  visibleModal,
  titleModal,
  shouldShowModal,
  formDataCheckEmail,
  formErrorsCheckEmail,
  formDataConfirmEmail,
  formErrorsConfirmEmail,
  shouldShowPasswordToText,
  // shouldShowPasswordToText2,
  formDataLogin,
  formErrorsLogin,
  enableLoginPassword,
  checkClientDocument,
  recoverAccount,
  biometricFaceRequest,
  onAnalysisComplete,
  formDataAddress,
  formErrorsAddress,
  // formDataRegister,
  // formErrorsRegister,
  formDataRegisterConfirm,
  formErrorsRegisterConfirm,
  formDataChangeClientData,
  formErrorsChangeClientData,
  formDataChangePassword,
  formErrorsChangePassword,
  name,
  children,
  showCloseButton,
  disableCloseOutside,
  formDataChangePasswordDocument,
  formErrorsChangePasswordDocument,
  onGoTo,
  handleOnSignIn,
  handleOnSignUp,
  handleOnLogout,
  onSubmitLogout,
  onCloseModal,
  handleOnCart,
  onToggleModal,
  onShouldShowModal,
  onChangeFormCheckEmail,
  onSendConfirmEmail,
  onChangeFormConfirmEmail,
  onConfirmEmail,
  onResendEmail,
  onChangeFormInputLogin,
  onCheckCPF,
  onSubmitLogin,
  onChangeFormInputAddress,
  onChangeCEPAddress,
  onSaveAddress,
  onTogglePasswordToText,
  // onTogglePasswordToText2,
  // onChangeFormInputRegister,
  // onChangeCEP,
  // onSubmitRegister,
  // formDataForgotPassword,
  // formErrorsForgotPassword,
  // onChangeFormInputForgotPassword,
  onSubmitForgotPassword,
  biometricCheckFaceRequest,
  onAnalysisCheckFaceComplete,
  onAnalysisCheckFaceError,
  onChangeFormInputRegisterConfirm,
  onSubmitRegisterConfirm,
  onChangePersonData,
  onSubmitChangeClientData,
  onChangeFormInputChangeClientData,
  onChangeFormInputChangePassword,
  onSubmitChangePassword,
  onSubmitResendCode,
  onSubmitResendEmail,
  isUserEmail,
  onSupportClick,
  onChangeFormChangePasswordDocument,
  onSubmitDocument,
}) => (
  <>
    <div className="wrapper w-full">
      <Header
        homepage={homepage}
        notifications={notifications}
        goTo={onGoTo}
        handleOnSignIn={handleOnSignIn}
        handleOnSignUp={handleOnSignUp}
        handleOnCart={handleOnCart}
        handleOnLogout={handleOnLogout}
      />
      <main className="overflow-hidden">{children}</main>
      <Footer handleOnSignIn={handleOnSignIn} handleOnSignUp={handleOnSignUp} goTo={onGoTo} />
    </div>
    <SupportBotton onCLick={onSupportClick} />
    <Modal
      visible={visibleModal}
      title={titleModal}
      onSetVisible={onToggleModal}
      actions={[]}
      showCloseButton={showCloseButton}
      disableCloseOutside={disableCloseOutside}
    >
      {
        {
          [ShouldShowModal.LOGIN]: (
            <LoginContent
              state={state}
              shouldShowPasswordToText={shouldShowPasswordToText}
              // shouldShowPasswordToText2={shouldShowPasswordToText2}
              formData={formDataLogin}
              formErrors={formErrorsLogin}
              onChangeFormInput={onChangeFormInputLogin}
              enableLoginPassword={enableLoginPassword}
              onCheckCPF={onCheckCPF}
              onSubmit={onSubmitLogin}
              onTogglePasswordToText={onTogglePasswordToText}
              onShouldShowModal={onShouldShowModal}
            />
          ),
          [ShouldShowModal.ADDRESS]: (
            <AddressContent
              state={state}
              formData={formDataAddress}
              formErrors={formErrorsAddress}
              onChangeFormInput={onChangeFormInputAddress}
              onChangeCEP={onChangeCEPAddress}
              onSaveAddress={onSaveAddress}
            />
          ),
          [ShouldShowModal.BIOMETRIC_FACE]: (
            <BiometricFaceValid
              request={biometricFaceRequest}
              onAnalysisComplete={onAnalysisComplete}
            />
          ),
          [ShouldShowModal.BIOMETRIC_FACE_CHECK]: (
            <BiometricFaceCheck
              request={biometricFaceRequest}
              onAnalysisComplete={onAnalysisComplete}
            />
          ),
          [ShouldShowModal.CHECK_ACCOUNT_CONTENT]: (
            <CheckAccountContent
              state={state}
              formData={formDataCheckEmail}
              formErrors={formErrorsCheckEmail}
              onChangeFormInput={onChangeFormCheckEmail}
              onSendConfirmEmail={onSendConfirmEmail}
            />
          ),
          [ShouldShowModal.CHECk_EMAIL]: (
            <CheckEmailContent
              state={state}
              formData={formDataCheckEmail}
              formErrors={formErrorsCheckEmail}
              onChangeFormInput={onChangeFormCheckEmail}
              onSendConfirmEmail={onSendConfirmEmail}
              sendCodeEmail={!!(checkClientDocument && checkClientDocument.sendCodeEmail)}
            />
          ),
          [ShouldShowModal.CONFIRM_EMAIL]: (
            <ConfirmEmailContent
              state={state}
              formData={formDataConfirmEmail}
              formErrors={formErrorsConfirmEmail}
              onChangeFormInput={onChangeFormConfirmEmail}
              onConfirmEmail={onConfirmEmail}
              onResendEmail={onResendEmail}
            />
          ),
          // [ShouldShowModal.PERSONAL_DATA]: (
          //   <RegisterContent
          //     state={state}
          //     shouldShowPasswordToText={shouldShowPasswordToText}
          //     shouldShowPasswordToText2={shouldShowPasswordToText2}
          //     formData={formDataRegister}
          //     formErrors={formErrorsRegister}
          //     onChangeFormInput={onChangeFormInputRegister}
          //     onChangeCEP={onChangeCEP}
          //     onSubmit={onSubmitRegister}
          //     onTogglePasswordToText={onTogglePasswordToText}
          //     onTogglePasswordToText2={onTogglePasswordToText2}
          //     onShouldShowModal={onShouldShowModal}
          //   />
          // ),
          [ShouldShowModal.TERMS]: <TermsContent />,
          [ShouldShowModal.FORGOT_PASSWORD]: (
            <CallChangePasswordDocumentContent
              state={state}
              formData={formDataChangePasswordDocument}
              formErrors={formErrorsChangePasswordDocument}
              onChangeFormInput={onChangeFormChangePasswordDocument}
              onSubmit={onSubmitDocument}
            />
          ),
          [ShouldShowModal.FORGOT_PASSWORD_BIOMETRIC]: (
            <ForgotPasswordBiometricContent
              state={state}
              // sendCodeEmail={sendCodeEmail}
              // formData={formDataForgotPassword}
              // formErrors={formErrorsForgotPassword}
              // onChangeFormInput={onChangeFormInputForgotPassword}
              onSubmit={onSubmitForgotPassword}
            />
          ),
          [ShouldShowModal.FORGOT_PASSWORD_BIOMETRIC_FACE]: (
            <BiometriChangePassword
              request={biometricCheckFaceRequest}
              onAnalysisComplete={onAnalysisCheckFaceComplete}
              onAnalysisError={onAnalysisCheckFaceError}
            />
          ),
          [ShouldShowModal.CHECk_EMAIL_FORGOT_PASSWORD]: (
            <ChangePasswordCheckEmailContent
              email={recoverAccount && recoverAccount.email ? recoverAccount.email : ''}
              phone={recoverAccount && recoverAccount.phone ? recoverAccount.phone : ''}
              sendCodeEmail={
                !!(
                  recoverAccount &&
                  recoverAccount.recoveryStrategy === PasswordRecoveryStrategy.EMAIL
                )
              }
              isUserEmail={isUserEmail}
              onChangePersonData={onChangePersonData}
            />
          ),
          [ShouldShowModal.CONFIRM_EMAIL_FORGOT_PASSWORD]: (
            <ConfirmEmailForgotPasswordContent
              sendCodeEmail={
                !!(
                  recoverAccount &&
                  recoverAccount.recoveryStrategy === PasswordRecoveryStrategy.EMAIL
                )
              }
              email={recoverAccount && recoverAccount.email ? recoverAccount.email : ''}
              phone={recoverAccount && recoverAccount.phone ? recoverAccount.phone : ''}
              onToggle={onToggleModal}
              onSubmitResendEmail={onSubmitResendEmail}
            />
          ),
          [ShouldShowModal.CHANGE_CLIENT_DATA]: (
            <ChangeClientDataContent
              onSubmit={onSubmitChangeClientData}
              formData={formDataChangeClientData}
              onChange={onChangeFormInputChangeClientData}
              formErrors={formErrorsChangeClientData}
              state={state}
            />
          ),
          [ShouldShowModal.CALL_CHANGE_PASSWORD]: (
            <CallChangePasswordContent name={name} onShouldShowModal={onShouldShowModal} />
          ),
          [ShouldShowModal.CHANGE_PASSWORD]: (
            <ChangePasswordContent
              state={state}
              shouldShowPasswordToText={shouldShowPasswordToText}
              formData={formDataChangePassword}
              formErrors={formErrorsChangePassword}
              onChangeFormInput={onChangeFormInputChangePassword}
              onSubmit={onSubmitChangePassword}
              onTogglePasswordToText={onTogglePasswordToText}
            />
          ),
          [ShouldShowModal.CONFIRM_REGISTER]: (
            <RegisterConfirmContent
              state={state}
              formData={formDataRegisterConfirm}
              formErrors={formErrorsRegisterConfirm}
              onChangeFormInput={onChangeFormInputRegisterConfirm}
              onSubmit={onSubmitRegisterConfirm}
              recoverAccount={recoverAccount}
              onSubmitResendCode={onSubmitResendCode}
              onChangePersonData={onChangePersonData}
            />
          ),
          [ShouldShowModal.LOGOUT]: (
            <LogoutContent onCancelConfirm={onCloseModal} onOkConfirm={onSubmitLogout} />
          ),
        }[shouldShowModal]
      }
    </Modal>
  </>
);
